import React from 'react';
import { motion } from 'framer-motion';
export const Hook: React.FC = () => {
  return <section className="py-20 px-6 sm:px-8 lg:px-12 max-w-4xl mx-auto border-t border-gold/30" data-id="element-118">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12" data-id="element-119">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase mb-4 block" data-id="element-120">
          The Silent Killer
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-forest-dark mb-6" data-id="element-121">
          Did you know that 1 out of every 2 dogs in the US will face a cancer
          diagnosis this year?
        </h2>
        <p className="text-lg text-charcoal/80 leading-relaxed max-w-2xl mx-auto" data-id="element-122">
          It's not "bad luck" or "just genetics." It's the ultra-processed
          "Yellow Bag" sitting in your pantry. But what if you could switch off
          those disease genes using simple items from your local Kroger?
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative rounded-xl overflow-hidden shadow-2xl border border-gold/20" data-id="element-123">
        <img src="https://cdn.magicpatterns.com/uploads/hkojWT1J3rxtFsiMNFKToE/thumbail.png" alt="Comparison of dog eye, processed kibble, and fresh whole foods" className="w-full h-auto object-cover" data-id="element-124" />
      </motion.div>
    </section>;
};